import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Box from "../../../components/Box";
import { storeActivityIndicator } from '../../../redux/reducers/authSlice';
import { DashboardService } from '../../../services/DashboardService';
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import toast from "react-hot-toast";
import BasicDashboardItem from '../Components/BasicDashboardItem';
import { GetAntrepoDashboard1Response, GetAntrepoDashboard1ResponseData } from '../../../models/response/dashboard/GetAntrepoDashboard1Response';

const AntrepoDashboard1 = () => {
    const [data, setData] = useState<GetAntrepoDashboard1ResponseData | undefined>(undefined);
    const dispatch = useDispatch();

    useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        try {
            dispatch(storeActivityIndicator(true));

            var response: GetAntrepoDashboard1Response = await DashboardService.getAntrepoDashboard1();

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <KTCard>
            <KTCardBody>
                <Box mb='2rem'>
                    <h2 className='m-0 p-0'>Antrepo</h2>
                </Box>

                {
                    data && (
                        <Box>
                            <Box flexDirection='row' gap='2.25rem'>
                                <BasicDashboardItem label='Açık Beyanname' value={data.numberOfOpenDeclarations.toString()} />
                                <BasicDashboardItem label='Kapalı Beyanname' value={data.numberOfClosedDeclarations.toString()} />
                                <BasicDashboardItem label='Devir Beyanname' value={data.numberOfTransferDeclarations.toString()} />
                                <BasicDashboardItem label='Redrese Beyanname' value={data.numberOfRedreseDeclarations.toString()} />
                            </Box>

                            <Box mt='2.25rem' flexDirection='row' gap='2.25rem'>
                                <BasicDashboardItem label='Açık Beyanname Toplam Kap Adet' value={data.totalOfOpenDeclarationsPotQuantity.toString()} />
                                <BasicDashboardItem label='Açık Beyanname Toplam Ağırlık' value={data.totalOfOpenDeclarationsGrossWeight.toFixed(2)} />
                                <BasicDashboardItem label='Kilitli Beyanname' value={data.numberOfLocks.toString()} />
                                <BasicDashboardItem label='6 Ay Çıkışı Olmayan Beyanname' value={data.numberOfDeclarationWithNoExitFor6Months.toString()} />
                                {/* <Box flex={1 / 4}>&nbsp;</Box> */}
                            </Box>
                        </Box>
                    )
                }


                {/* <Box mt='2.25rem' flexDirection='row' gap='2.25rem'>
                    <Box flex={1 / 4}>
                        <KTCard className='dashboard-kpi'>
                            <Box p='15px'>
                                <Box flexDirection='row'>
                                    <Box justifyContent='center'>
                                        <i style={{ color: '#535353', fontSize: '18px' }} className='fa fa-users' />
                                    </Box>
                                    <Box ml='10px' justifyContent='center'>
                                        <h3 style={{ color: '#535353' }} className='m-0 p-0'>Açık Beyanname</h3>
                                    </Box>
                                </Box>

                                <Box mt='15px' flexDirection='row'>
                                    <Box flexGrow={1} justifyContent='center'>
                                        &nbsp;
                                    </Box>
                                    <Box justifyContent='center'>
                                        <h1 style={{ fontSize: '40px', color: '#1B84FF' }} className='m-0 p-0'>17</h1>
                                    </Box>
                                    <Box ml='10px' justifyContent='center'>
                                        <i style={{ color: '#17c653', fontSize: '18px' }} className='fa fa-chevron-up' />
                                    </Box>
                                </Box>
                            </Box>
                        </KTCard>
                    </Box>

                    <Box flex={1 / 4}>
                        <KTCard className='dashboard-kpi'>
                            <Box p='15px'>
                                <Box flexDirection='row'>
                                    <Box justifyContent='center'>
                                        <i style={{ color: '#535353', fontSize: '18px' }} className='fa fa-users' />
                                    </Box>
                                    <Box ml='10px' justifyContent='center'>
                                        <h3 style={{ color: '#535353' }} className='m-0 p-0'>Kapalı Beyanname</h3>
                                    </Box>
                                </Box>

                                <Box mt='15px' flexDirection='row'>
                                    <Box flexGrow={1} justifyContent='center'>
                                        &nbsp;
                                    </Box>
                                    <Box justifyContent='center'>
                                        <h1 style={{ fontSize: '40px', color: '#1B84FF' }} className='m-0 p-0'>17</h1>
                                    </Box>
                                    <Box ml='10px' justifyContent='center'>
                                        <i style={{ color: '#17c653', fontSize: '18px' }} className='fa fa-chevron-up' />
                                    </Box>
                                </Box>
                            </Box>
                        </KTCard>
                    </Box>

                    <Box flex={1 / 4}>
                        <KTCard className='dashboard-kpi'>
                            <Box p='15px'>
                                <Box flexDirection='row'>
                                    <Box justifyContent='center'>
                                        <i style={{ color: '#535353', fontSize: '18px' }} className='fa fa-users' />
                                    </Box>
                                    <Box ml='10px' justifyContent='center'>
                                        <h3 style={{ color: '#535353' }} className='m-0 p-0'>Devir Beyanname</h3>
                                    </Box>
                                </Box>

                                <Box mt='15px' flexDirection='row'>
                                    <Box flexGrow={1} justifyContent='center'>
                                        &nbsp;
                                    </Box>
                                    <Box justifyContent='center'>
                                        <h1 style={{ fontSize: '40px', color: '#1B84FF' }} className='m-0 p-0'>17</h1>
                                    </Box>
                                    <Box ml='10px' justifyContent='center'>
                                        <i style={{ color: '#17c653', fontSize: '18px' }} className='fa fa-chevron-up' />
                                    </Box>
                                </Box>
                            </Box>
                        </KTCard>
                    </Box>

                    <Box flex={1 / 4}>
                        <KTCard className='dashboard-kpi'>
                            <Box p='15px'>
                                <Box flexDirection='row'>
                                    <Box justifyContent='center'>
                                        <i style={{ color: '#535353', fontSize: '18px' }} className='fa fa-users' />
                                    </Box>
                                    <Box ml='10px' justifyContent='center'>
                                        <h3 style={{ color: '#535353' }} className='m-0 p-0'>Redrese Beyanname</h3>
                                    </Box>
                                </Box>

                                <Box mt='15px' flexDirection='row'>
                                    <Box flexGrow={1} justifyContent='center'>
                                        &nbsp;
                                    </Box>
                                    <Box justifyContent='center'>
                                        <h1 style={{ fontSize: '40px', color: '#1B84FF' }} className='m-0 p-0'>17</h1>
                                    </Box>
                                    <Box ml='10px' justifyContent='center'>
                                        <i style={{ color: '#17c653', fontSize: '18px' }} className='fa fa-chevron-up' />
                                    </Box>
                                </Box>
                            </Box>
                        </KTCard>
                    </Box>
                </Box> */}
            </KTCardBody>
            {/* <KTCardBody className='py-4'>
                        <div className='table-responsive'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th>{item.title}</th>
                                            )
                                        }
                                    </tr>
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                    /> */}
        </KTCard>
    )
}

export default AntrepoDashboard1;